module.exports = __webpack_public_path__ + "static/img/Test-active.d055a687.svg";